export default __webpack_public_path__ + "static/media/noaccess.f874318a.png";